import { ReactNode } from 'react';

import { Skeleton } from 'components/Blocks';

import { FullPendingActions, usePendingActions } from 'providers/PendingActions';
import { useProject } from 'providers/Project';

interface LocalActionWrapperProps {
  children: ReactNode;
  currentAction: FullPendingActions;
}

export function ProjectLoadWrapper({ children, currentAction }: LocalActionWrapperProps) {
  const { loadingProjects } = useProject();

  const { pendingEntries } = usePendingActions();

  const isLocal = pendingEntries[currentAction].type === 'LOCAL';

  if (!isLocal) return <>{children}</>;

  if (loadingProjects) return <Skeleton quantity={4} height={80} />;

  return <>{children}</>;
}
